const INVOICE_STATUS = {
    ACTIVE: 'ACTIVE',
    CANCELLED: 'CANCELLED',
}

export default INVOICE_STATUS
